"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();
